import { graphql } from "../../generated"

export const ORGANIZATION_MEMBERSHIP_ACCESS_UPDATE_QRY = graphql(`
    query OrganizationMembershipAccessUpdateQry(
        $input: OrganizationMembershipsByIDsInput!
    ) {
        organizationMembershipsByIDs(input: $input) {
            organizationMemberships {
                subject {
                    id
                    identity {
                        fullName
                    }
                    organization {
                        id
                        name
                        descendants {
                            id
                            name
                        }
                    }
                }
                role
                managedAccess
                wellPermissions {
                    id
                    well {
                        id
                        name
                    }
                }
            }
        }
        wells(first: 10000) {
            nodes {
                organization {
                    id
                }
                id
                name
            }
        }
    }
`)
